export default __webpack_public_path__ + "static/chocpops-taste-3-desktop-3281c0913c27cca546370c530347d659.png";